<template>
    <div id="noReturnShopHeadHome">
        <!-- 承载头部位没有返回商城的页面 -->
        <vHeader></vHeader>
        <noReturnShopHead></noReturnShopHead>
        <div class="contain">
            <router-view />
        </div>
        <footerCopy></footerCopy>
    </div>
</template>

<script>
import vHeader from "@/components/common/topHead";
import noReturnShopHead from "@/components/common/noReturnShopHead";
import footerCopy from "@/components/common/footerCopy";

export default {
    name: "noReturnShopHeadHome",
    data() {
        return {};
    },
    components: {
        vHeader: vHeader,
        noReturnShopHead: noReturnShopHead,
        footerCopy: footerCopy
    }
};
</script>

<style>
.bottomW{
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/noReturnShopHeadHome.vue